import { Injectable } from '@angular/core';
import { List } from '../models/Commons/List';

@Injectable()
export class TreeDataService {
  selectList: any;
  constructor() { }
  //获取树形数据
  public getTreeData(data: Array<any>,
    idFilter: string,
    textFilter: string,
    parentFilter: string): Array<any> {

    var comboTreeConfigList = new List<any>();
    comboTreeConfigList.pushRange(data);
    return this.getChildNodes(null, comboTreeConfigList, idFilter, textFilter, parentFilter);
  }

  private getChildNodes(parentId,
    comboTreeConfigList: List<any>,
    idFilter: string,
    textFilter: string,
    parentFilter: string) {

    var leveln = comboTreeConfigList.select(x => x[parentFilter] == parentId);
    var treeData = [];
    leveln.forEach((x, index) => {
      var node = {
        id: x[idFilter],
        text: x[textFilter]
      }
      treeData.push(node);
      var childs = this.getChildNodes(x[idFilter], comboTreeConfigList, idFilter, textFilter, parentFilter);
      if (childs == null || childs.length == 0)
        return;
      node["nodes"] = childs;
    })
    return treeData;
  }

  //获取树形数据
  public getNzTreeData(parentId, data,
    idFilter: string,
    textFilter: string,
    parentFilter: string,
    icon?: string): Array<any> {
    data = Array.isArray(data) ? data : [].concat(data);
    var comboTreeConfigList = new List<any>();
    comboTreeConfigList.pushRange(data);
    return this.getNzChildNodes(parentId, comboTreeConfigList, idFilter, textFilter, parentFilter, icon);
  }

  //处理check树选择框数据
  public getCheckTreeData(data, title, key, value, checked, selectArray) {
    let TreeNodes = [];
    data.forEach(element => {
      let node = {
        title: "",
        key: "",
        value: "",
        checked: Boolean,
        isLeaf: false,
        children: [],
      };
      node.title = element[title];
      node.key = element[key];
      node.value = element[value];
      node.children = element.children != undefined ? this.getCheckTreeData(element.children, title, key, value, checked, selectArray) : null;
      if (node.children) {
        node.isLeaf = false;
      } else {
        node.isLeaf = true;
      }
      TreeNodes.push(node);
      if (element.checked === true) {
        selectArray.push(element.id);
      }
    });
    return TreeNodes;
  }

  //处理check树选择框数据
  public getCheckPermTree(data, title, key, showdisabled, level: number) {
    let TreeNodes = [];
    data.forEach(element => {
      let node = {
        title: "",
        key: "",
        action: "",
        method: "",
        service: "",
        keyCode: "",
        permid: "",
        checked: false,
        isLeaf: false,
        expanded: false,
        disabled: false,
        dependencyText:"",
        children: [],
      };
      node.title = element[title];
      node.key = element[key];
      node.action = element["action"];
      node.permid = element["permid"];
      node.method = element["method"];
      node.service = element["service"];
      node.keyCode = element["keyCode"];
      node.checked = element["_checked"];
      node.dependencyText=element["dependencyText"]
      node.children = element.children != undefined ? this.getCheckPermTree(element.children, title, key, showdisabled, level + 1) : [];
      if (node.children.length > 0) {
        node.isLeaf = false;
      } else {
        node.isLeaf = true;
      }
      node.expanded = level > 0 ? false : true
      if (parseInt(node.permid)<0) {
        node.disabled =true
      }
      TreeNodes.push(node);
    });
    return TreeNodes;
  }
  //处理check树已选择数据
  public getCheckData(data, title, key, selectNodes) {
    data.forEach(element => {
      let node = {
        title: "",
        key: "",
        action: "",
        method: "",
        service: "",
        keyCode: "",
        checked: false,
        isLeaf: false,
        expanded: false,
        dependencyText:"",
        children: [],
      };
      node.title = element[title];
      node.key = element[key];
      node.action = element["action"];
      node.method = element["method"];
      node.service = element["service"];
      node.keyCode = element["keyCode"];
      node.checked = element["_checked"];
      node.dependencyText=element["dependencyText"]
      node.children = element.children != undefined ? this.getCheckData(element.children, title, key, selectNodes) : null;
      if (node.children) {
        node.isLeaf = false;
      } else {
        node.isLeaf = true;
      }
      node.expanded = !node.isLeaf
      if (node.checked == true) {
        selectNodes.push(node.key);
      }
    });
    return selectNodes;
  }

  //处理check树展开数据
  public getExpandData(data, title, key, expandNodes) {
    data.forEach(element => {
      let node = {
        title: "",
        key: "",
        action: "",
        method: "",
        service: "",
        keyCode: "",
        checked: false,
        isLeaf: false,
        dependencyText:"",
        children: [],
      };
      node.title = element[title];
      node.key = element[key];
      node.action = element["action"];
      node.method = element["method"];
      node.service = element["service"];
      node.keyCode = element["keyCode"];
      node.checked = element["_checked"];
      node.dependencyText=element["dependencyText"]
      node.children = element.children != undefined ? this.getExpandData(element.children, title, key, expandNodes) : [];
      if (element.children.length > 0) {
        node.isLeaf = false;
      } else {
        node.isLeaf = true;
      }
      if (node.isLeaf == false) {
        expandNodes.push(node.key);
      }
    });
    return expandNodes;
  }

  //获取选择框数据
  public getSelectData(data, id, name) {
    let selectNodes = [];
    data.forEach(element => {
      let node = {
        label: String,
        value: Number,
      };
      node.label = element[name];
      node.value = element[id];
      selectNodes.push(node);
    });
    return selectNodes;
  }

  private getNzChildNodes(parentId,
    comboTreeConfigList: List<any>,
    idFilter: string,
    textFilter: string,
    parentFilter: string,
    icon?: string) {
    var leveln
    if (parentId == null) {
      //查找父级为null的第一级
      leveln = comboTreeConfigList.select(x => x[parentFilter] == null);
    } else if (parentId == 0) {
      //查找父级为0的第一级
      leveln = comboTreeConfigList.select(x => x[parentFilter] == 0);
    } else
      leveln = comboTreeConfigList.select(x => x[parentFilter] == parentId);
    var treeData = [];
    leveln.forEach((x, index) => {
      var node = {
        key: x[idFilter],
        title: x[textFilter],
        isLeaf: false,
        expanded: true,
        icon: icon,
        children: this.getNzChildNodes(x[idFilter], comboTreeConfigList, idFilter, textFilter, parentFilter, icon)
      }
      if (node.children == null || node.children.length == 0) {
        node.isLeaf = true;
      }
      treeData.push(node);
    })
    return treeData;
  }
}
